.picker-point.point-inner {
  top: 40px;
  color: #a7a7a7;
  transform-origin: center 90px;
}

.picker-point {
  cursor: pointer;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
}

.picker-center,
.picker-point {
  position: absolute;
  left: 50%;
  border-radius: 50%;
}

.picker-point.point-outter {
  top: 5px;
  color: #5d5d5d;
  transform-origin: center 125px;
}
